import { VARIANT_PICKER_ERROR, VARIANT_PICKER_GET, VARIANT_PICKER_GET_VARIANT_URL, VARIANT_PICKER_RECEIVE, VARIANT_PICKER_RECEIVE_VARIANT_URL } from '../Actions/VariantPicker.action';

const DEFAULT_STATE = { 
    items: null,
    error: null,
    variantUrl: null
};

export const variantPicker = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case VARIANT_PICKER_GET:
        case VARIANT_PICKER_GET_VARIANT_URL:
        case VARIANT_PICKER_RECEIVE:
        case VARIANT_PICKER_RECEIVE_VARIANT_URL:
        case VARIANT_PICKER_ERROR:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}